export const hero = {
	image: require("../../assets/imgs/heavy-up/intro.png"),
	imageAlt: "Range Rover Sport driving along a gravel path",
};

export const collageImage = require("../../assets/imgs/heavy-up/collage.jpg");

export const programVideo = require("../../assets/imgs/heavy-up/packages.mp4");

export const plans = [
	{
		id: "demand-capture",
		index: "01",
		title: "Demand Capture",
		price: "$3,000",
		description:
			"Growth score clears threshold, but one full-acceleration gate needs improvement. Unique leads and appointments / 1K model visits.",
		features: ["Google Ads", "Meta", "~CTV / OLV"],
		cta: "Select Demand Capture",
	},
	{
		id: "growth",
		index: "02",
		title: "Growth Plan",
		price: "$5,000",
		description:
			"Strong funnel readiness plus reach opportunity; positive inventory engagement vs. traffic. Incremental sold VINs; Appointments / 1K model visits.",
		features: ["Google Ads", "Meta", "CTV / OLV"],
		cta: "Select Growth Plan",
	},
	{
		id: "acceleration",
		index: "03",
		title: "Acceleration Plan",
		price: "$7,500",
		description:
			"Signs of growth, limited scale/data, or incomplete sales identity. Qualified inventory sessions; validated unique leads.",
		features: ["Google Ads", "Meta", "CTV / OLV"],
		cta: "Select Acceleration Plan",
	},
];

/** JotForm — JLR Heavy Up Enroll Form 2026. Source export: src/pages/HeavyUp/jotform-source/ */
export const HEAVY_UP_FORM_ID = "262643934625160";

export function findPlanById(id) {
	return plans.find((p) => p.id === id) || null;
}
